export default __webpack_public_path__ + "static/media/portada_TonyEsposito.35e8e8ac.jpg";